import { UserRoles } from "../types/user";

export const USER_ROLE_LABELS: Record<UserRoles, string> = {
  root:  "Quản trị hệ thống",
  admin: "Quản trị viên",
  sales: "Nhân viên Kinh doanh",
  debt:  "Nhân viên Thu hồi nợ",
};

const SELECTABLE_ROLES: UserRoles[] = ["admin", "sales", "debt"];

export const ROLE_OPTIONS = SELECTABLE_ROLES.map((value) => ({
  value,
  label: USER_ROLE_LABELS[value],
}));
